/**
 * 资金预警提示
 */
import React, { useEffect, useState } from 'react';
import { AdPlatformTypeName, CustomerStatus } from '@/model/agency';
import { AD_PLATFORM_TYPE_RULE } from '@/constants/Constants';
import globalStore from '@/stores';
// import { getLackAdvertiserCount } from './api';
import { listGdt } from '@/api/operator/cgi/smb/account/gdt';
import { hasRole } from '@/services';
import commonReport from '@/common/common-report';
import { reportUserBehavior } from '@/pages/agency/utils/util';
import { RoleType } from '@/model/role';
import cancelManager from '@/api/operator/middlewares/cancel-manager';

import './index.scoped.less';

interface FinanceAlertTipProps {
  platform?: AdPlatformTypeName[];
  onQuery?: () => void; // 列表查询
  onlyLabel?: boolean; // 只显示标签
}

const REQ_CANCEL_TOKEN = 'finance-alert-request';

const FinanceAlertTip: React.FC<FinanceAlertTipProps> = (props) => {
  const { platform = [AdPlatformTypeName.adq, AdPlatformTypeName.cps], onQuery, onlyLabel = false } = props;
  const { account, history } = globalStore;
  const { agency_list } = account;

  const [count, setCount] = useState(0);

  const getLackCount = async () => {
    const agency_uid_list = platform.map((platformName) => agency_list
      .filter((v) => v.customer_status === CustomerStatus.normal)
      .filter(AD_PLATFORM_TYPE_RULE[platformName]))
      .flat()
      .map((v) => v.agency_uid);
    const res: any = await listGdt({
      data: {
        agency_uid_list,
        balance_status: 2,
        exist_wallet_id: 0,
        need_operator_data: 0,
        need_summary_data: 0,
      },
    }, false, {
      isCancel: false,
      cancelToken: REQ_CANCEL_TOKEN,
    });
    const count = res?.data?.conf?.total_num || 0;
    setCount(count);
    if (count > 0) {
      commonReport.reportAction('finance-alert-view');
      reportUserBehavior({ behaviorType: 'finance-alert-view' });
    }
  };

  useEffect(() => {
    if (onlyLabel) return;
    getLackCount();
    // 取消请求以避免重复上报
    return () => {
      cancelManager.abort(REQ_CANCEL_TOKEN);
    };
  }, [onlyLabel]);

  const handleTransfer = () => {
    reportUserBehavior({ behaviorType: 'finance-alert-click-transfer' });
    history.push('/agency/finance/alert/balance?status_type=Lack&alert_type=advertiser');
  };

  const handleQuery = () => {
    reportUserBehavior({ behaviorType: 'finance-alert-click-query' });
    if (onQuery) {
      onQuery?.();
    } else {
      history.push('/agency/advertiser-list/tencent?params={"balance_status":2,"exist_wallet_id":0}');
    }
  };

  if (onlyLabel) {
    return <div className="finance-alert-tip">
      <span
        className="operation"
        data-report={hasRole(RoleType.observer) ? 'finance-alert-click-query' : 'finance-alert-click-transfer'}
        onClick={hasRole(RoleType.observer) ? handleQuery : handleTransfer}
      >资金预警</span>
    </div>;
  }
  return count > 0 ? <div className="finance-alert-tip">
    <span>{count}个近期有消耗的账户余额不足</span>
    {
      !hasRole(RoleType.observer) ? (
        <span
          className="operation"
          data-report="finance-alert-click-transfer"
          onClick={handleTransfer}
        >去转入</span>
      ) : (
        <span
          className="operation"
          data-report="finance-alert-click-query"
          onClick={handleQuery}
        >立即查看</span>
      )
    }
  </div> : null;
};

export default FinanceAlertTip;
